import { VISA_SB, VENTA_ONLINE_HOST_LIVE, VENTA_ONLINE_HOST_SANDBOX, ASSETS_URL_VENTA_ONLINE_LIVE, ASSETS_URL_VENTA_ONLINE_SANDBOX } from '../shared/constants';


const getUrlAndResourcesPath = () => {
    const storedUrl = localStorage.getItem('currentHost');

    const ResourcesPath = storedUrl.includes(VENTA_ONLINE_HOST_SANDBOX) ?
        ASSETS_URL_VENTA_ONLINE_SANDBOX :
        storedUrl.includes(VENTA_ONLINE_HOST_LIVE) ?
            ASSETS_URL_VENTA_ONLINE_LIVE :
            window.env.ASSETS_URL;

    return { ResourcesPath };
};

const useVisaSensoryBranding = (cardData, cardLogos, ASSETS_URL) => {
    if (cardLogos[cardData.payment_method_id] === VISA_SB.credit ||
        cardLogos[cardData.payment_method_id] === VISA_SB.debit ||
        cardLogos[cardData.payment_method_id] === VISA_SB.prepaid
    ) {
        const { ResourcesPath } = getUrlAndResourcesPath();

        const script = document.createElement('script');
        script.src = `${ResourcesPath}${VISA_SB.scriptPath}`
        script.async = true;

        script.onload = () => {
            if (window.VisaSensoryBranding && typeof window.VisaSensoryBranding.init === 'function') {
                window.VisaSensoryBranding.init(VISA_SB.cfg, `${ResourcesPath}${VISA_SB.dirLocationPath}`);
                window.VisaSensoryBranding.show();
            }
        };
        document.body.appendChild(script);
        return true;
    } else return false;
};

export default useVisaSensoryBranding;

